import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { tbPanels } from "../tbModulesData";
import TbImagePlaceholder from "./TbImagePlaceholder";

const FeatureGrid: React.FC<{ left: string[]; right: string[] }> = ({ left, right }) => (
  <div className="tb-panel__features">
    <ul className="tb-panel__list">
      {left.map((item) => (
        <li key={item}>
          <span className="tb-panel__dot" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
    <ul className="tb-panel__list">
      {right.map((item) => (
        <li key={item}>
          <span className="tb-panel__dot" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const TbPanelsSection: React.FC = () => {
  return (
    <section className="tb-panels" aria-labelledby="tb-panels-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="tb-panels-title" className="wdev-section-head__title">
            Admin &amp; Driver App Panels
          </h2>
          <p className="tb-panels__lead">
            Fully integrated panels to manage your taxi business and empower drivers on the road.
          </p>
        </AnimatedSection>

        <div className="tb-panels__stack">
          {tbPanels.map((panel, index) => (
            <motion.article
              key={panel.id}
              className={`tb-panel ${panel.imagePosition === "right" ? "tb-panel--reverse" : ""}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: index * 0.1 }}
            >
              <div className="tb-panel__visual">
                <TbImagePlaceholder
                  variant={panel.id === "admin" ? "wide" : "phone"}
                  label={panel.placeholderLabel}
                  hint={panel.placeholderHint}
                  className="tb-panel__placeholder"
                />
              </div>

              <div className="tb-panel__content">
                <h3 className="tb-panel__title">{panel.title}</h3>
                <p className="tb-panel__desc">{panel.description}</p>
                <FeatureGrid left={panel.featuresLeft} right={panel.featuresRight} />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TbPanelsSection;
